module.exports = __webpack_public_path__ + "static/media/jackpot-card.01d4da69.png";